import { IS_DESKTOP } from '@/config/platform';
if (!IS_DESKTOP) {
  window.api = {
    getVersion() {
      return __APP_VERSION__;
    },
    checkUpdate() {
      return null;
    },
    close() {
      window.close();
    },
    minimize() {},
    maximize() {},
    openExternal(url) {
      window.open(url, '_blank');
    },
    update() {},
    onUpdateDownloaded() {
      return () => {};
    },
    onUpdateProgress() {
      return () => {};
    },
  };

  // Le cadre de démonstration du site vitrine partage son origine avec
  // l'application : sans cloisonnement, il lit le `localStorage` du visiteur et
  // ouvre SON compte au lieu du compte de démonstration — et une écriture de la
  // démo écraserait la vraie session, dans l'onglet resté ouvert à côté.
  //
  // On bascule donc la démo sur `sessionStorage`, propre au contexte de
  // navigation : elle ne voit pas la vraie session, ne peut pas l'altérer, et
  // disparaît avec l'onglet. Le choix se fait sur l'URL, jamais sur une clé
  // stockée — celle-ci vivrait déjà dans l'espace qu'il faut choisir.
  const isDemoFrame =
    new URLSearchParams(window.location.search).get('demo') === '1';
  const backing = isDemoFrame ? window.sessionStorage : window.localStorage;
  const listeners = new Set<(key: StoreKeys, value: string | null) => void>();

  window.store = {
    clear() {
      backing.clear();
    },
    get<T>(key: StoreKeys) {
      return backing.getItem(key) as T | null;
    },
    set(key, value) {
      if (value === null) backing.removeItem(key);
      else backing.setItem(key, value);
      for (const listener of listeners) listener(key, value);
    },
    onChange(listener) {
      listeners.add(listener);
    },
  };
}
